import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

import { Container, Row, Col, ContainerFluid } from '../../../../../SPRINTA/atoms/Grid'
import Font from '../../../../../SPRINTA/atoms/Font'
import Box from '../../../../../SPRINTA/atoms/Box'
import Button from '../../../../../SPRINTA/atoms/Button'
import Loading from '../../../../../SPRINTA/atoms/Loading'
import BoxScroll from '../../../../../SPRINTA/atoms/BoxScroll'
import NotificationItem from '../../../../../SPRINTA/molecules/NotificationItem'
import BoxEvent from '../../../../../SPRINTA/molecules/BoxEvent'
import Placeholder from '../../../../../SPRINTA/atoms/PlaceHolder'
import Timeline from '../../../../../SPRINTA/organisms/Timeline'
import SlickSlider from '../../../../../SPRINTA/third-party/SlickCarousel'
import * as user from '../../../../utils/user'
import T from '../../../../../SPRINTA/translate/T'

class Home extends Component {
      lastProps = {}

      state = {
            loadingNotifications: false,
            loadingEvents: false,
            dataEvents: [],
            dataExperience: [],
            dataNotifications: [],
            totalNotifications: null
      }

      componentWillMount() {
            this.componentWillUpdate(this.props)
      }

      componentWillUpdate(nextProps) {
            if(!this.lastProps.userData || this.lastProps.userData.profile !== nextProps.userData.profile) {
                  if(nextProps.userData.isMe)
                        this.loadNotifications()

                  this.loadEvents(nextProps.userData.profile.token || nextProps.userData.profile.username)
            }
            this.lastProps = nextProps
      }

      handleNotificationScroll(event) {
            if(event.target.scrollTop >= event.target.scrollHeight - event.target.clientHeight && !this.state.loadingNotifications) {
                  this.loadNotifications()
            }
      }

      loadNotifications() {
            if(this.state.totalNotifications !== null && this.state.dataNotifications.length >= this.state.totalNotifications) return

            this.setState({
                  loadingNotifications: true
            })

            user.getNotifications(this.state.dataNotifications.length, 20)
            .then(data => {
                  this.setState({
                        dataNotifications: [
                              ...this.state.dataNotifications,
                              ...data.result
                        ],
                        totalNotifications: data.total,
                        loadingNotifications: false
                  })
            })
      }

      loadEvents(username) {
            this.setState({
                  loadingEvents: true
            })

            user.eventsFuture(username, 0, 6)
            .then(data => {
                  this.setState({
                        dataEvents: data.result.list
                  })
            })
            
            user.getExperience(username, 0, 6)
            .then(data => {
                  this.setState({
                        dataExperience: data.result.list,
                        loadingEvents: false,
                  })
            })
      }     

      render() {
            return (
                  <div>
                        {(this.state.dataEvents.length > 0 || this.props.userData.isMe) && (
                              <Container style={{padding: '30px 0'}}>
                                    {this.props.userData.isMe && (
                                          <Col size={`12 ${this.props.userData.isMe ? '4' : '12'}`}>
                                                <Box>
                                                      <Font heading="4" color='#666' weight='100' style={{margin: '0'}}>
                                                            {T.text('your_inscriptions')}
                                                            <Row>
                                                                  <Col>
                                                                        <BoxScroll height='292px' onScroll={event => this.handleNotificationScroll(event)}>
                                                                              {this.state.totalNotifications === 0 ? (
                                                                                    <span style={{fontSize: '12px'}}> {T.text('zero_notifications')} </span>
                                                                              ) : (
                                                                                    this.state.dataNotifications.map((item, idx) => (
                                                                                          <NotificationItem
                                                                                                key={item.id}
                                                                                                avatar={`${window.URL_BASE_OLD}${item.image}`}
                                                                                                link={`${window.URL_BASE_OLD}${item.link}`}
                                                                                                html={item.description}
                                                                                                style={{
                                                                                                      borderBottom: `${idx === this.state.dataNotifications.length - 1 ? '0' : '1'}px solid #fff`
                                                                                                }}
                                                                                          />
                                                                                    ))

                                                                              )}
                                                                              {this.state.loadingNotifications && (
                                                                                    <div style={{marginTop: '12px', float: 'left', width: '100%', text: 'center'}}>
                                                                                          <Loading />
                                                                                    </div>
                                                                              )}
                                                                        </BoxScroll>
                                                                  </Col>
                                                            </Row>
                                                      </Font>
                                                </Box>
                                          </Col>
                                    )}
                                    {this.state.dataEvents.length > 0 && (
                                          <Col size={`12 ${this.props.userData.isMe ? '8' : '12'}`}>
                                                <Row style={{marginTop:'30px'}}>
                                                      <Col size='12 4'>
                                                            <Font heading="4" color='#666' weight='100'>
                                                                  <b>{T.text('events')}</b>
                                                            </Font>
                                                      </Col>
                                                      <Col size={`12 8`}>
                                                            <Row>
                                                                  {this.props.userData.isMe && (
                                                                        <Col size='6 5'>
                                                                              <a href={window.createEvent}>
                                                                                    <Button theme='primary'>{T.text('create_event')}</Button>
                                                                              </a>
                                                                        </Col>
                                                                  )}
                                                                  <Col size={`6 ${this.props.userData.isMe ? '7' : '4'}`} float='right'>
                                                                        <Link to={`/user/${this.props.match.params.user}/events`}>
                                                                              <Button theme='light'>{T.text('see_all_events')}</Button>
                                                                        </Link>
                                                                  </Col>
                                                            </Row>
                                                      </Col>

                                                      <Col>
                                                            {this.state.loadingEvents ? (
                                                                  <Row>
                                                                        <Col size='6'>
                                                                              <Placeholder type='retangle' style={{height: '200px'}} />
                                                                        </Col>
                                                                        <Col size='6'>
                                                                              <Placeholder type='retangle' style={{height: '200px'}} />
                                                                        </Col>
                                                                  </Row>
                                                            ) : (
                                                                  <Row>
                                                                        <SlickSlider itens={this.props.userData.isMe ? 2 : 3}>
                                                                              {this.state.dataEvents.map(item => (
                                                                                    <Col size='6' key={item.id}>
                                                                                          <a href={`/${item.kind}/${item.token}`}>
                                                                                                <BoxEvent
                                                                                                      data={{
                                                                                                            cover: item.coverImagePath || null,
                                                                                                            type: item.kind,
                                                                                                            date: item.startDate,
                                                                                                            state_abbreviation: item.region,
                                                                                                            city: item.city,
                                                                                                            title: item.title,

                                                                                                      }}
                                                                                                />
                                                                                          </a>
                                                                                    </Col>
                                                                              ))}
                                                                        </SlickSlider>
                                                                  </Row>
                                                            )}

                                                      </Col>
                                                </Row>
                                          </Col>
                                    )}
                                    {this.state.dataExperience.length > 0 && (
                                          <Col size={`12`}>
                                                <Row style={{marginTop:'30px'}}>
                                                      <Col size='12 7'>
                                                            <Font heading="4" color='#666' weight='100'>
                                                                  <b>{T.text('experiences')}</b>
                                                            </Font>
                                                      </Col>
                                                      <Col size={`12 5`}>
                                                            <Row>
                                                                  {this.props.userData.isMe && (
                                                                        <Col size='6 5'>
                                                                              <a href={window.createEvent}>
                                                                                    <Button theme='primary'>{T.text('create_experience')}</Button>
                                                                              </a>
                                                                        </Col>
                                                                  )}
                                                                  <Col size={`6 ${this.props.userData.isMe ? '7' : '4'}`} float='right'>
                                                                        <Link to={`/user/${this.props.match.params.user}/experiences`}>
                                                                              <Button theme='light'>{T.text('see_all_events')}</Button>
                                                                        </Link>
                                                                  </Col>
                                                            </Row>
                                                      </Col>

                                                      <Col>
                                                            {this.state.loadingEvents ? (
                                                                  <Row>
                                                                        <Col size='6'>
                                                                              <Placeholder type='retangle' style={{height: '200px'}} />
                                                                        </Col>
                                                                        <Col size='6'>
                                                                              <Placeholder type='retangle' style={{height: '200px'}} />
                                                                        </Col>
                                                                  </Row>
                                                            ) : (
                                                                  <Row>
                                                                        <SlickSlider itens={3}>
                                                                              {this.state.dataExperience.map(item => (
                                                                                    <Col size='6' key={item.id}>
                                                                                          <a href={`/x/${item.friendlyUrl ? item.friendlyUrl : item.token}`}>
                                                                                                <BoxEvent
                                                                                                      data={{
                                                                                                            cover: item.cover ? item.cover.url : null,
                                                                                                            type: 'experience',
                                                                                                            state_abbreviation: item.region,
                                                                                                            city: item.city,
                                                                                                            title: item.title,

                                                                                                      }}
                                                                                                />
                                                                                          </a>
                                                                                    </Col>
                                                                              ))}
                                                                        </SlickSlider>
                                                                  </Row>
                                                            )}

                                                      </Col>
                                                </Row>
                                          </Col>
                                    )}
                              
                              </Container>
                        )}


                        <ContainerFluid style={{backgroundColor: '#f9f9f9', marginTop: '30px', padding: '30px 0'}}>
                              <Container>
                                    <Row>
                                          <Col>
                                                <Timeline
                                                      type='profile'
                                                      id={this.props.userData.profile.token}
                                                      user={this.props.user}
                                                      isLogged={this.props.user.userData ? true : false}
                                                      />
                                          </Col>
                                    </Row>
                              </Container>
                        </ContainerFluid>
                  </div>
            )
      }
}

const mapStateToProps = store => ({
   user: store.user
})
const mapDispatchToProps = {

}
export default connect( mapStateToProps, mapDispatchToProps )(Home)


// WEBPACK FOOTER //
// ./src/App/pages/Profile/Pages/Home/index.js